// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2ltxd","checkboxCol":"Table_checkboxCol__25kw8","emailCol":"Table_emailCol__3iWvK","actionCol":"Table_actionCol__24cNw"};